export default __webpack_public_path__ + "static/media/isabel2.d04f67ef.jpg";